/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./NftItemPurchaseDialog.vue?vue&type=template&id=57c701c4&scoped=true"
import script from "./NftItemPurchaseDialog.vue?vue&type=script&lang=js"
export * from "./NftItemPurchaseDialog.vue?vue&type=script&lang=js"
import style0 from "./NftItemPurchaseDialog.vue?vue&type=style&index=0&id=57c701c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c701c4",
  null
  
)

export default component.exports